import { FunctionComponent } from "react";
import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCol,
  IonGrid,
  IonLabel,
  IonRow,
} from "@ionic/react";
import { SiteModel } from "../models/site.model";
import { useSiteCard } from "../hooks/use-site-card.hook";

export const SiteCard: FunctionComponent<{
  site: SiteModel;
}> = ({ site }) => {
  const { photoURI, handlerImageError, metas } = useSiteCard(site);

  return (
    <IonCard style={{ marginTop: 10 }}>
      <img
        src={photoURI}
        alt=""
        onError={handlerImageError}
        style={{ height: 150, width: "100%", objectFit: "cover" }}
      />
      <IonCardHeader style={{ padding: "10px 20px" }}>
        <IonCardSubtitle color={"tertiary"}>{site.address}</IonCardSubtitle>
      </IonCardHeader>
      {metas.length > 0 && (
        <IonCardContent style={{ padding: "0 10px 10px 10px" }}>
          <IonGrid style={{ padding: 0 }}>
            <IonRow>
              {metas.map((meta) => (
                <IonCol key={meta.label} size="6" style={{ display: "flex", flexDirection: "column" }}>
                  <IonLabel className={"indicators"} style={{ fontWeight: "bold" }}>
                    {meta.value}
                  </IonLabel>
                  <IonLabel style={{ fontSize: "0.6rem" }}>{meta.label}</IonLabel>
                </IonCol>
              ))}
            </IonRow>
          </IonGrid>
        </IonCardContent>
      )}
    </IonCard>
  );
};
